import { render } from "./AboutOurCreative.vue?vue&type=template&id=2e4dcaca"
import script from "./AboutOurCreative.vue?vue&type=script&lang=js"
export * from "./AboutOurCreative.vue?vue&type=script&lang=js"

import exportComponent from "/home/harry/Desktop/Vuejs Project/Sudavas/sudavas.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__